import React from 'react';
import { MergeIngredientInputs } from '../mergeIngredients/MergeIngredientInputs';

export const SplittedInputField = (props) => {
  const { fields } = props;
  return fields.map((currentElement, index, array) => {
    if (index % 2 === 0 && index < array.length - 1) {
      const nextElement = array[index + 1];
      return (
        <div id={`splittedinputfield-wrapper-${index}`} key={index}>
          <div id={`splittedinputfield-row-${index}`} className="grid grid-flow-col gap-1">
            <div id={`ingredient-input-left-${index}`} className="ingredient-input-container">
              <MergeIngredientInputs inputField={currentElement}></MergeIngredientInputs>
            </div>
            <div id={`merge-input-right-${index}`} className="ingredient-input-container">
              <MergeIngredientInputs inputField={nextElement}></MergeIngredientInputs>
            </div>
          </div>
        </div>
      );
    }
    return null; // Skip the last element
  });
};
